var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var GENERATE_COUNT = 28;
var STEP = 18;
var INITIAL_INDENT = 18;
var hierarchyIndents = Array.from({ length: GENERATE_COUNT })
    .reduce(function (result, _item, index) {
    result.push(result[index] + STEP);
    return result;
}, [INITIAL_INDENT])
    .map(function (item) { return "".concat(item, "px"); });
export var getUiTheme = function (colorSchema, themeProps) {
    if (themeProps === void 0) { themeProps = {}; }
    return (__assign({ fontSizes: [0, "0.5rem", "0.75rem", "1rem", "1.25rem", "1.5rem"], lineHeights: ["1rem"], sizes: [0, "0.25rem", "0.5rem", "0.75rem", "1rem", "1.25rem"], space: [0, "0.25rem", "0.5rem", "0.75rem", "1rem", "1.25rem"], hierarchyMargin: __spreadArray([0], hierarchyIndents, true), hierarchyPos: __spreadArray([], hierarchyIndents, true), borders: [
            "none",
            "1px solid ".concat(colorSchema.contrast),
            "1px solid ".concat(colorSchema.text),
            "1px solid ".concat(colorSchema.highlight),
        ], colors: __assign(__assign({}, colorSchema), { tableRow: [
                colorSchema.contrast,
                colorSchema.base,
            ] }) }, themeProps));
};
//# sourceMappingURL=theme.js.map